/**
 * What an offer the SharePoint import marked 'incompleta' still lacks.
 *
 * Same checks as app/api/domain/models/Opportunity/completeness.py: the card
 * shows the backend's `oferta.missing_fields`, the modal recomputes them live
 * from the form so the list shrinks while the user fills it in, and the state
 * goes back to 'borrador' once nothing is missing.
 */

export const INCOMPLETE_STATE = 'incompleta'
export const COMPLETE_STATE = 'borrador'

export const MISSING_FIELD_LABELS: Record<string, string> = {
    otd_code: 'Código de oferta (OTD)',
    venta: 'Venta',
    coste_interno: 'Coste interno',
    profiles: 'Perfiles (roles requeridos)',
}

export interface OfferCompletenessInput {
    oferta_code: string
    venta: string
    coste_interno: string
    time_material: boolean
    /** Internal projects have no price. */
    interno: boolean
    roleCount: number
}

export const offerMissingFields = (offer: OfferCompletenessInput): string[] => {
    const missing: string[] = []
    if (!offer.oferta_code.trim()) missing.push('otd_code')
    // A T&M offer is billed by the hours logged in Redmine.
    if (!offer.time_material && !offer.interno) {
        if (!String(offer.venta).trim()) missing.push('venta')
        if (!String(offer.coste_interno).trim()) missing.push('coste_interno')
    }
    if (offer.roleCount === 0) missing.push('profiles')
    return missing
}

/** "Venta, Perfiles (roles requeridos)" for a list of missing-field keys. */
export const missingFieldsText = (missing: string[] | null | undefined): string =>
    (missing || []).map((key) => MISSING_FIELD_LABELS[key] || key).join(', ')
